import Vue from 'vue'
import moment from 'moment'
import { MeasureUnitName, OutTypeName, TransTypeName, ORDERTAG, AllocateStatusName, SOURCENAME, WarehouseTypeName, OrderStatusName, OrderOutStatusName, RefundTypeName, RefundStatusName, CheckStatusName, PrintStatusName, OutStatusName, OrderOutTypeName } from '../utils/index'
import NP from 'number-precision'
import store from '../store.js'
const CustomFilter = {}
CustomFilter.install = function(Vue) {
  Vue.filter('measureUnitName', function(index) {
    const item = MeasureUnitName.find(i => i.value === +index) || {}
    return item.label || ''
  })
  Vue.filter('warehouseName', function(value) {
    if (!value) return ''
    return (store.state.account.warehouse.find(i => i.warehouseNo === value) || {}).warehouseName
  })

  Vue.filter('expressName', function(value) {
    if (!value) return ''
    return (store.state.account.expressList.find(i => i.expressId === +value) || {}).expressTempletName
  })
  Vue.filter('departmentName', function(value) {
    if (!value) return ''
    return (store.state.account.department.find(i => i.departmentId === +value) || {}).departmentName
  })
  Vue.filter('numberPrecision', function(val) {
    return NP.divide(val, 100)
  })
  Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    if (!dataStr) {
      return ''
    }
    return moment(dataStr).format(pattern)
  })
  Vue.filter('loginType', function(type) {
    const LoginType = {
      100: '企业端',
      200: '监管端',
      202: '监管端',
      208: '监管端',
      1000: '运营端'
    }
    return LoginType[type]
  })
  Vue.filter('outTypeName', function(index) {
    const item = OutTypeName.find(i => i.value === +index) || {}
    return item.label || '-'
  })
  Vue.filter('warehouseTypeName', function(index) {
    const item = WarehouseTypeName.find(i => i.value === +index) || {}
    return item.label || '-'
  })
  Vue.filter('allocateStatusName', function(index) {
    const item = AllocateStatusName.find(i => i.value === +index) || {}
    return item.label || '-'
  })
  Vue.filter('transTypeName', function(index) {
    const item = TransTypeName.find(i => i.value === +index) || {}
    return item.label || '-'
  })
  Vue.filter('orderOutTypeName', function(index) {
    const item = OrderOutTypeName.find(i => i.value === +index) || {}
    return item.label
  })

  Vue.filter('sourceName', function(index) {
    const item = SOURCENAME.find(i => i.value === +index) || {}
    return item.label
  })

  Vue.filter('outStatusName', function(index) {
    const item = OutStatusName.find(i => i.value === +index) || {}
    return item.label
  })

  Vue.filter('orderStatusName', function(index) {
    const item = OrderStatusName.find(i => i.value === +index) || {}
    return item.label
  })

  Vue.filter('checkStatusName', function(index) {
    const item = CheckStatusName.find(i => i.value === +index) || {}
    return item.label
  })

  Vue.filter('orderOutStatusName', function(index) {
    const item = OrderOutStatusName.find(i => i.value === +index) || {}
    return item.label
  })

  Vue.filter('refundTypeName', function(index) {
    const item = RefundTypeName.find(i => i.value === +index) || {}
    return item.label
  })
  Vue.filter('refundStatusName', function(index) {
    const item = RefundStatusName.find(i => i.value === +index) || {}
    return item.label
  })
  Vue.filter('printStatusName', function(index) {
    const item = PrintStatusName.find(i => i.value === +index) || {}
    return item.label
  })
  Vue.filter('inspectionStatus', function(type, needAudit) {
    // 1，未检验2，检验中；3，合格；4，不合格；9，召回
    const LoginType = {
      1: '未检验',
      2: '检验中',
      3: '合格',
      4: '不合格',
      9: '召回'
    }
    return needAudit === 1 ? LoginType[type] || '' : ''
  })
  Vue.filter('orderTagName', function(index) {
    const item = ORDERTAG.find(i => i.value === +index) || {}
    return item.label
  })
  Vue.filter('tagType', function(type) {
    const typeMap = {
      1: '定制标签',
      2: '涂层标签',
      3: '芯片标签',
      4: '普通标签',
      5: '一品一码标签'
    }
    if (Array.isArray(type)) {
      return type.map(o => typeMap[o]).join(',')
    }
    return typeMap[type]
  })
  Vue.filter('vasMap', function(type) {
    const typeMap = {
      1: '物流',
      2: '小程序',
      3: '新零售'
    }
    return typeMap[type]
  })
  Vue.filter('trialFlag', function(type) {
    const typeMap = {
      1: '试用',
      0: '正式'
    }
    return typeMap[type] || ''
  })
  Vue.filter('orderStatus', function(type) {
    const typeMap = {
      0: '有效',
      1: '过期',
      2: '有效',
      3: '过期'
    }
    return typeMap[type] || ''
  })
  Vue.filter('tradeType', function(type) {
    const typeMap = {
      1: '进出口贸易',
      3: '国内贸易'
    }
    if (Array.isArray(type)) {
      return type.map(o => typeMap[o]).join(',')
    }
    return typeMap[type]
  })
  Vue.filter('outstockStatus', function(type) {
    const typeMap = {
      0: '新建',
      1: '部分出库',
      2: '全部出库',
      3: '已关闭'
    }
    return typeMap[type]
  })

  Vue.filter('aftersaleStatus', function(type) {
    const typeMap = {
      0: '新建',
      2: '已处理',
      9: '关闭'
    }
    return typeMap[type] || ''
  })

  Vue.filter('codingType', function(type) {
    const typeMap = {
      1: '建批赋码',
      2: '出库赋码'
    }
    if (Array.isArray(type)) {
      return type.map(o => typeMap[o]).join(',')
    }
    return typeMap[type]
  })
  Vue.filter('batchStatus', function(type) {
    const typeMap = {
      0: '待完善',
      1: '未检',
      2: '检验中',
      3: '合格',
      4: '不合格',
      9: '召回'
    }
    return typeMap[type]
  })
  Vue.filter('tagModel', function(type) {
    const typeMap = {
      1: '产品码',
      2: '套码'
    }
    if (Array.isArray(type)) {
      return type.map(o => typeMap[o]).join(',')
    }
    return typeMap[type]
  })
  Vue.filter('traceInfo', function(type) {
    const typeMap = {
      1: '种植环境',
      2: '养殖环境',
      3: '生产环境'
    }
    return typeMap[type]
  })
  Vue.filter('tagCount', function(count) {
    return ('0000000000' + count).slice(-10)
  })

  Vue.filter('imageFixed', function(src, width = 750) {
    // eslint-disable-next-line no-underscore-dangle
    const _url = src.split('.')
    // eslint-disable-next-line no-underscore-dangle
    const _index = _url.length - 2
    // eslint-disable-next-line no-underscore-dangle
    _url[_index] = `${_url[_index]}_${width}x0`
    return _url.join('.')
  })

  Vue.filter('getFilename', function(file) {
    if (file.indexOf('originalfilename') > -1) {
      return file.split('originalfilename')[1].slice(1)
    }
    return file
  })

  Vue.filter('abnormalType', function(type) {
    const typeMap = {
      1: '串货异常',
      2: '扫码次数异常',
      3: '扫码位置异常'
    }
    return typeMap[type]
  })

  Vue.filter('currency', function(num) {
    const reg = /\d{1,3}(?=(\d{3})+$)/g
    return (num + '').replace(reg, '$&,')
  })

  Vue.filter('linkTypeName', function(type) {
    const LoginType = {
      0: '门户内容',
      1: '商品',
      3: '抽奖活动',
      4: '积分活动',
      5: '限时优惠',
      6: '专区',
      11: '商品组',
      13: '专区',
      10: '追溯页面'
    }
    return LoginType[type]
  })
}

Vue.use(CustomFilter)
